var map = {
	"./1x/Asset 5.png": "0fab",
	"./1x/ballon-right.png": "8781",
	"./1x/coin-lock.png": "55b3",
	"./1x/money-lock.png": "d599",
	"./arrow-chat.png": "7a4f",
	"./arrow-down.png": "a284",
	"./arrow-message.png": "f721",
	"./arrow-of-double.png": "9097",
	"./arrow_brown.png": "1f10",
	"./ballon-right.png": "f95d",
	"./calendar-mini.png": "384d",
	"./candidate-azul.png": "eaff",
	"./candidate-blue.png": "0beb",
	"./candidate-green.png": "93ed",
	"./candidate-icon.png": "319d",
	"./candidate-laranja.png": "4569",
	"./candidate-orange.png": "4f9b",
	"./candidate-purple.png": "e429",
	"./candidate-rosa.png": "ef0a",
	"./candidate-roxo.png": "f5ce",
	"./chat-button-icon.png": "72cf",
	"./chat-button.png": "c8c8",
	"./chat-icon.png": "7af8",
	"./clock-mini.png": "54da",
	"./clock.png": "2b5f",
	"./decode-correct.png": "761f",
	"./decode-logo-dash.png": "b4b9",
	"./decode-logo.png": "ee56",
	"./drop-zone-start.png": "12a1",
	"./emoticon.png": "b032",
	"./enigma-button.png": "cae8",
	"./error.png": "1fe8",
	"./feedback-icon.png": "150e",
	"./game-disabled.png": "e43f",
	"./game-expired.png": "8d4b",
	"./game-finished.png": "1913",
	"./game-scheduled-game.png": "de53",
	"./game-started-game.png": "98e0",
	"./huddle-logo.png": "e893",
	"./logo-decode-white.png": "97ae",
	"./logo-repense-white.png": "fbc9",
	"./logo-white.png": "d939",
	"./logo.png": "cf05",
	"./losang-waiting.png": "b86f",
	"./menu.png": "2c36",
	"./money-error.png": "5e43",
	"./money-success.png": "4216",
	"./money-total.png": "4421",
	"./moneyout.png": "eb9d",
	"./person-1.png": "f423",
	"./person-2.png": "bbea",
	"./person-3.png": "d1bd",
	"./report-disabled.png": "afb3",
	"./report-open.png": "6c23",
	"./report_arrow_left.png": "91fb",
	"./report_arrow_left_active.png": "16d8",
	"./report_arrow_right.png": "a1d4",
	"./report_arrow_right_active.png": "5e79",
	"./schedule-block.png": "7bab",
	"./schedule-dash-open.png": "4137",
	"./schedule-finished.png": "baf2",
	"./schedule-scheduled-expired.png": "7a25",
	"./schedule-scheduled.png": "2063",
	"./schedule-success.png": "4a92",
	"./score.png": "340d",
	"./success-icon.png": "d0aa",
	"./timeout.png": "92df",
	"./warning.png": "73f5",
	"./xis-feedback-2.png": "d06d",
	"./xis-feedback.png": "798d",
	"./xis-small.png": "1d29"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";